export default {
  namespaced: true,
  state: {
    copied: '',
    isShiftPress: false,
    fragmentsClipboard: []
  },
  mutations: {
    SET_COPIED(state, copied) {
      state.copied = copied
    },

    SET_IS_SHIFT_PRESS(state, isShiftPress) {
      state.isShiftPress = isShiftPress
    },

    SET_FRAGMENTS_CLIPBOARD(state, fragmentsClipboard) {
      state.fragmentsClipboard = fragmentsClipboard
    }
  }
}